// Los Amigos — multi-location ordering app.
// Each entry becomes its own router under basePath (see src/index.js Root).
// losamigossc shares the losamigos menu via the mapping in Context/ShopData.js;
// its settings (hours / ordering) live under its own r_id on the backend.
let locationsData = [
  {
    id: 'losamigos',
    shopId: 'losamigos',
    basePath: "/burbank",
    cssGlobalPrefix: 'losamigosall',
    label: "Burbank",
    address: ["2825 W Olive Ave", "Burbank, CA 91505"],
    phone: "818-842-3700",
    phoneLink: "+18188423700",
    orderLink: "/burbank/order",
    hours: [
      { day: 'Sun-Thu', hours: '11am-10pm' },
      { day: 'Fri-Sat', hours: '11am-1am' },
    ]},

  {
    id: 'losamigossc',
    shopId: 'losamigossc',
    basePath: "/santa-clarita",
    cssGlobalPrefix: 'losamigosall',
    label: "Santa Clarita",
    address: ["23320 Valencia Blvd", "Santa Clarita, CA 91355"],
    phone: "661-244-8064",
    phoneLink: "+16612448064",
    orderLink: "/santa-clarita/order",
    hours: [
      { day: 'Sun-Thu', hours: '11am-10pm' },
      { day: 'Fri-Sat', hours: '11am-11pm' },
    ]},
]

export default locationsData
